"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _View = _interopRequireDefault(require("../View"));
var _styles = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty({
      display: "flex",
      overflowX: "hidden",
      position: "relative",
      height: "auto",
      flexDirection: "column",
      flexShrink: 0,
      paddingTop: function paddingTop(_ref) {
        var dense = _ref.dense;
        return dense ? 0 : 16;
      },
      paddingBottom: function paddingBottom(_ref2) {
        var dense = _ref2.dense;
        return dense ? 0 : 16;
      },
      paddingLeft: function paddingLeft(_ref3) {
        var disableGutters = _ref3.disableGutters;
        return disableGutters ? 0 : "16px";
      },
      paddingRight: function paddingRight(_ref4) {
        var disableGutters = _ref4.disableGutters;
        return disableGutters ? 0 : "16px";
      }
    }, theme.breakpoints.up("md"), {
      paddingLeft: function paddingLeft(_ref5) {
        var disableGutters = _ref5.disableGutters;
        return disableGutters ? 0 : "24px";
      },
      paddingRight: function paddingRight(_ref6) {
        var disableGutters = _ref6.disableGutters;
        return disableGutters ? 0 : "24px";
      }
    }),
    fullHeight: {
      flexGrow: 1,
      height: "100%",
      flexShrink: "initial"
    },
    scroll: {
      overflowY: "scroll"
    },
    wrapper: {
      flexDirection: "row",
      justifyContent: "space-between"
    }
  };
}, {
  name: "GgSidePageBody"
});
var NewSidePageBody = function NewSidePageBody(_ref7) {
  var children = _ref7.children,
    loading = _ref7.loading,
    fetching = _ref7.fetching,
    disableGutters = _ref7.disableGutters,
    gutterTop = _ref7.gutterTop,
    wrapper = _ref7.wrapper,
    dense = _ref7.dense,
    _ref7$scroll = _ref7.scroll,
    scroll = _ref7$scroll === void 0 ? true : _ref7$scroll,
    _ref7$fullHeight = _ref7.fullHeight,
    fullHeight = _ref7$fullHeight === void 0 ? true : _ref7$fullHeight;
  var classes = useStyles({
    disableGutters: disableGutters,
    gutterTop: gutterTop,
    dense: dense
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
    loading: loading,
    fetching: fetching,
    "data-cy-role": "sidePageBodyView",
    className: (0, _clsx2["default"])(classes.root, _defineProperty(_defineProperty(_defineProperty({}, classes.wrapper, wrapper), classes.scroll, scroll), classes.fullHeight, fullHeight)),
    children: children
  });
};
var _default = exports["default"] = NewSidePageBody;